// extracted by mini-css-extract-plugin
export default {"grid_item":"Signup_grid_item__jHPhy","grid_text_label":"Signup_grid_text_label__sdLDz","grid_container":"Signup_grid_container__g9ox5"};